<template>
    <card class="card-pricing bg-gradient-default border-0 text-center mb-4"
        header-classes="bg-transparent"
        body-classes="px-lg-7"
        footer-classes="bg-transparent"
    >

        <div class="display-3 text-white mb-3">
            <span class="text-muted d-inline">{{ registration.cohort.name }}</span>
            <span class="text-muted d-inline"> / {{ registration.degree.name }}</span>
            <span class="d-inline text-muted">/</span>
            <span class="d-inline">{{ simulation.name }}</span>
        </div>

        <div class="mt-4 mb-2" v-if="sync">
            <span :class="'sync-notice bg-' + sync.color">
                <strong>{{ $t('pwa.offline-mode') }}:</strong> {{ $t('pwa.local-notice-' + sync.color) }}
            </span>
        </div>

    </card>
</template>

<script>
    export default {

        props: {
            registration: {
                type: Object,
                required: true
            },

            simulation: {
                type: Object,
                required: true
            },

            statusData: {
                type: Array,
                required: true
            },

            statusColors: {
                type: Object,
                required: true
            },

            sync: {
                type: Object,
                default: null
            },
        },

        methods: {

            statusColor(status) {
                return this.statusColors[status]
            },

            statusLabel(status) {
                return this.statusData.find(item => item.id == status).name
            },
        }
    }
</script>

<style lang="css" scoped>

    .sync-notice {
        color: #ffffff;
        padding: .2rem .6rem;
        border-radius: .375rem;
        font-size: 0.8rem;
    }

</style>